
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as healthPOjGGhE3p5c3SA493NjhOwlDQQH5eqcD_4568NCOeSvo0Meta } from "/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/health.vue?macro=true";
import { default as _91_46_46_46slug_939SzyCgdnaMWwSZxHjMsYVGmE74tfQpgCaQ3E2K5vw0MMeta } from "/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[...slug].vue?macro=true";
import { default as guidesu3NoeVmge9GvYHMq1NYl4iDXM_ssTxV1KcHbpWAyWVAMeta } from "/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/guides.vue?macro=true";
import { default as port_45parkingYZiP0yq1gi51Aoby6hAfICKHnm6IKsS0m2TBBK9O9GYMeta } from "/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/port-parking.vue?macro=true";
import { default as airport_45parkingobf4X8FreKHgoCvnnenpx3qaLGv0eiVTGxbd9tR5KoEMeta } from "/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/airport-parking.vue?macro=true";
import { default as parking_45couponsAmqLOovHh_06aBRf_z_V8YVEx7grmac5tvg_45_NO66E8Meta } from "/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/parking-coupons.vue?macro=true";
import { default as _91result_935czaOYbm_45Mc8qw1g33vEJRvbPa8wOFW2aYIsaiLRJdQMeta } from "/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/flight-status/[result].vue?macro=true";
import { default as airport_45shuttlesWd8g1oDA8N5XwhHMJK2dS1MdJYAFjldKesah_45f5eTbwMeta } from "/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/airport-shuttles.vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_933vbOjrt_6A2mU_45WSXKQhIEzK8EaFgPGALZP3rDUaOZgMeta } from "/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/hro/[code]-[name]-[IATA].vue?macro=true";
import { default as indexRlIwXf4j3eZLtGuaYXsrA9H_cz5byR_45PaHFEWBCa4XAMeta } from "/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/shuttles/[airport]/index.vue?macro=true";
import { default as off_45airport_45parking_qdb_45eoaPjXbXnkv25_QHcrEw9HeZv9qr_BYRlPdw4EMeta } from "/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/off-airport-parking.vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_93MNt6HQpr37D8wpEKuesNF6g8vt25eEYBa3vXeNWP3NwMeta } from "/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/parking/[code]-[name]-[IATA].vue?macro=true";
import { default as _91product_93M2_45u3sOnX6lkX9Lqt1kilZYpVPpCf65arL3lRjprtQcMeta } from "/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/shuttles/[airport]/[product].vue?macro=true";
import { default as port_45hotels_45with_45parkingx2TShVGxu_45qwb1Ynid5c5HrhjgsIf2NiD397AF_6XLIMeta } from "/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/port-hotels-with-parking.vue?macro=true";
import { default as airport_45hotels_45with_45parkingjVkqOE2jxCA1A2WR4KNvfpRChpD7aqlX5tqnchsWwgMMeta } from "/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/airport-hotels-with-parking.vue?macro=true";
import { default as _91code_93_45_91name_93_45_91IATA_93ih6tCr1_45iuKmH3ddXJx7cgq88hQVxQjgnuvuI0QQxxAMeta } from "/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/hotel-package/[code]-[name]-[IATA].vue?macro=true";
import { default as component_45stubb4OWj8CcTJBrHMEQBknDYU6nq1uC9I_45DUorZayxlYPUMeta } from "/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@24.5.1_db0@0.3.2_eslint@9.35.0_jiti@2.5.1_175d35522c5ff3c9f3b87bd77dd6c13f/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubb4OWj8CcTJBrHMEQBknDYU6nq1uC9I_45DUorZayxlYPU } from "/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/node_modules/.pnpm/nuxt@3.16.2_@parcel+watcher@2.5.1_@types+node@24.5.1_db0@0.3.2_eslint@9.35.0_jiti@2.5.1_175d35522c5ff3c9f3b87bd77dd6c13f/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "health___en",
    path: "/health",
    component: () => import("/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/health.vue")
  },
  {
    name: "slug___en",
    path: "/:slug(.*)*",
    component: () => import("/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[...slug].vue")
  },
  {
    name: "IATA-guides___en",
    path: "/:IATA()/guides",
    component: () => import("/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/guides.vue")
  },
  {
    name: "IATA-port-parking___en",
    path: "/:IATA()/port-parking",
    component: () => import("/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/port-parking.vue")
  },
  {
    name: "IATA-airport-parking___en",
    path: "/:IATA()/airport-parking",
    component: () => import("/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/airport-parking.vue")
  },
  {
    name: "IATA-parking-coupons___en",
    path: "/:IATA()/parking-coupons",
    component: () => import("/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/parking-coupons.vue")
  },
  {
    name: "flight-status-result___en",
    path: "/flight-status/:result()",
    component: () => import("/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/flight-status/[result].vue")
  },
  {
    name: "IATA-airport-shuttles___en",
    path: "/:IATA()/airport-shuttles",
    component: () => import("/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/airport-shuttles.vue")
  },
  {
    name: "hro-code-name-IATA___en",
    path: "/hro/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/hro/[code]-[name]-[IATA].vue")
  },
  {
    name: "shuttles-airport___en",
    path: "/shuttles/:airport()",
    meta: indexRlIwXf4j3eZLtGuaYXsrA9H_cz5byR_45PaHFEWBCa4XAMeta || {},
    component: () => import("/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/shuttles/[airport]/index.vue")
  },
  {
    name: "IATA-off-airport-parking___en",
    path: "/:IATA()/off-airport-parking",
    component: () => import("/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/off-airport-parking.vue")
  },
  {
    name: "parking-code-name-IATA___en",
    path: "/parking/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/parking/[code]-[name]-[IATA].vue")
  },
  {
    name: "shuttles-airport-product___en",
    path: "/shuttles/:airport()/:product()",
    meta: _91product_93M2_45u3sOnX6lkX9Lqt1kilZYpVPpCf65arL3lRjprtQcMeta || {},
    component: () => import("/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/shuttles/[airport]/[product].vue")
  },
  {
    name: "IATA-port-hotels-with-parking___en",
    path: "/:IATA()/port-hotels-with-parking",
    component: () => import("/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/port-hotels-with-parking.vue")
  },
  {
    name: "IATA-airport-hotels-with-parking___en",
    path: "/:IATA()/airport-hotels-with-parking",
    component: () => import("/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/airport-hotels-with-parking.vue")
  },
  {
    name: "hotel-package-code-name-IATA___en",
    path: "/hotel-package/:code()-:name()-:IATA()",
    component: () => import("/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/hotel-package/[code]-[name]-[IATA].vue")
  },
  {
    name: "Guides___en",
    path: "/:IATA([a-z]{3})",
    component: () => import("/codebuild/output/src3932096889/src/bitbucket.org/magusa/cavu-workspaces/apps/apr/pages/[IATA]/guides.vue")
  },
  {
    name: component_45stubb4OWj8CcTJBrHMEQBknDYU6nq1uC9I_45DUorZayxlYPUMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubb4OWj8CcTJBrHMEQBknDYU6nq1uC9I_45DUorZayxlYPU
  }
]